import React, { useEffect, useState } from "react";
import { apiPost } from "../../service/admin/apiService";
import { showError, showSuccess } from "../../utils/toast";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  Spinner,
} from "react-bootstrap";
import { BsPlus, BsX, BsSend, BsKeyFill } from "react-icons/bs";

const ChallanDetail = ({
  show,
  onHide,
  formName,
  selectedFYearId,
  selectedMonth,
  challanAmt,
  selectedYear,
}) => {
  const [challanData, setChallanData] = useState([]);
  const [showChallanModal, setShowChallanModal] = useState(false);
  const [challanAmount, setChallanAmount] = useState(challanAmt);
  const [interest, setInterest] = useState("0.00");
  const [lateFee, setLateFee] = useState("0.00");
  const [bsrCode, setBsrCode] = useState("");
  const [challanDate, setChallanDate] = useState("");
  const [challanNumber, setChallanNumber] = useState("");
  const [challanLoading, setChallanLoading] = useState(false);
  const [challanId, setChallanId] = useState(0);
  const [showChallanLoader, setShowChallanLoader] = useState(false);
  let clientInfo = JSON.parse(localStorage.getItem("clientInfo"));

  useEffect(() => {
    getChallanInfo();
  }, []);

  useEffect(() => {
    if (show && challanData.length > 0) {
      clearChallanDetails();
      setChallanAmount(challanData[0].ca || "");
      setInterest(challanData[0].in || "");
      setLateFee(challanData[0].lf || "");
      setBsrCode(challanData[0].bc || "");
      setChallanDate(challanData[0].cd || "");
      setChallanNumber(challanData[0].cn || "");
      setChallanId(challanData[0].id);
    }
  }, [show, challanData]);

  const clearChallanDetails = () => {
    setChallanAmount("");
    setInterest("");
    setLateFee("");
    setBsrCode("");
    setChallanDate("");
    setChallanNumber("");
    setChallanId(0);
  };

  const getChallanInfo = async () => {
    // setShowChallanLoader(true);
    const payload = {
      action: "formlist",
      ty: "challandetails",
      to: clientInfo?.tk,
      fi: selectedFYearId,
      mn: selectedMonth,
      fona: formName,
    };
    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        // setShowChallanLoader(false);
      } else if (response?.responsedetails) {
        console.log("challan info", response?.responsedetails);
        setChallanData(response?.responsedetails);
        // setShowChallanLoader(false);
      }
    } catch (err) {
      console.error("Error:", err);
      //   setShowChallanLoader(false);
      showError("Something went wrong");
    }
  };

  const saveChallan = async () => {
    if (bsrCode.length < 7 || bsrCode.length > 7) {
      if (clientInfo?.client?.igoc === 1) {
        showError("Receipt Number should be of 7 digits");
      } else {
        showError("BSR Code should be of 7 digits");
      }
      return;
    }

    if (challanNumber.length < 5 || challanNumber.length > 5) {
      if (clientInfo?.client?.igoc === 1) {
        showError("DDO Seq. No. should be of 5 digits only");
      } else {
        showError("Challan Number should be of 5 digits only");
      }

      return;
    }

    setChallanLoading(true);

    const payload = {
      action: challanId !== 0 ? "formupdate" : "formadd",
      ty: "challandetails",
      fi: selectedFYearId,
      mn: selectedMonth,
      to: clientInfo?.tk,
      ca: challanAmount,
      in: interest,
      lf: lateFee,
      bc: bsrCode,
      cd: challanDate,
      cn: challanNumber,
      fona: formName,
      ...(challanId !== 0 && { id: challanId }),
    };
    console.log("Saving data:", payload);
    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);

      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        setChallanLoading(false);
      } else if (response?.responsedetails.success === "yes") {
        setTimeout(() => {
          getChallanInfo();
          clearChallanDetails();
          setChallanLoading(false);
          setShowChallanModal(false);
          showSuccess("Challan information updated successfully");
        }, 3000);
      }
    } catch (err) {
      console.error("Error:", err);
      showError("Something went wrong");
      setChallanLoading(false);
    }
  };

  function addZeroPrefix(num, length) {
    return num.toString().padStart(length, "0");
  }

  const handelChallanNumber = (value) => {
    if (value.length > 5) return;
    setChallanNumber(value);
  };
  const checkChallanNumber = (value) => {
    console.log("checkChallanNumber", value);
    if (value.length < 5 && value > 0) {
      setChallanNumber(addZeroPrefix(value, 5));
    }
  };

  const handelBsrCode = (value) => {
    if (value.length > 7) return;
    setBsrCode(value);
  };
  const checkBsrCode = (value) => {
    console.log("checkBsrCode", value);
    if (value.length < 7 && value > 0) {
      setBsrCode(addZeroPrefix(value, 7));
    }
  };

  console.log("challanDa", challanData);
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          onHide();
        }}
        centered
      >
        <Modal.Header className="custom-header" closeButton>
          <Modal.Title className="text-primary">Challan Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row} className="mb-2" controlId="challanAmount">
              <Form.Label column sm={4}>
                Challan Amount
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="number"
                  value={challanAmount}
                  onChange={(e) => setChallanAmount(e.target.value)}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-2" controlId="interest">
              <Form.Label column sm={4}>
                Interest
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="number"
                  value={interest}
                  onChange={(e) => setInterest(e.target.value)}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-2" controlId="lateFee">
              <Form.Label column sm={4}>
                Late Fee
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="number"
                  value={lateFee}
                  onChange={(e) => setLateFee(e.target.value)}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-2" controlId="totalAmount">
              <Form.Label column sm={4}>
                Total Amount
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="number"
                  value={
                    (parseFloat(challanAmount) || 0) +
                    (parseFloat(interest) || 0) +
                    (parseFloat(lateFee) || 0)
                  }
                  disabled
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-2" controlId="bsrCode">
              <Form.Label column sm={4}>
                {clientInfo?.client?.igoc === 1 ? "Receipt Number" : "BSR Code"}
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="number"
                  value={bsrCode}
                  // onChange={(e) => setBsrCode(e.target.value)}
                  onChange={(e) => handelBsrCode(e.target.value)}
                  onBlur={(e) => checkBsrCode(e.target.value)}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-2" controlId="challanDate">
              <Form.Label column sm={4}>
                {clientInfo?.client?.igoc === 1 ? "Date" : "Challan Date"}
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="date"
                  value={challanDate}
                  onChange={(e) => setChallanDate(e.target.value)}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-2" controlId="challanNumber">
              <Form.Label column sm={4}>
                {clientInfo?.client?.igoc === 1
                  ? "DDO Seq No."
                  : "Challan Number"}
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="number"
                  value={challanNumber}
                  // onChange={(e) => setChallanNumber(e.target.value)}
                  onChange={(e) => handelChallanNumber(e.target.value)}
                  onBlur={(e) => checkChallanNumber(e.target.value)}
                />
              </Col>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              saveChallan();
            }}
          >
            {challanLoading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2 " />
                Adding...
              </>
            ) : (
              <>
                <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                {challanData.length > 0 && challanData[0]?.id != ""
                  ? "Update"
                  : "Add"}
              </>
            )}
          </Button>
        </Modal.Footer>
        {/* {showChallanLoader ? <Loader show={showChallanLoader} /> : null} */}
      </Modal>
    </>
  );
};

export default ChallanDetail;
